import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, OnDestroy } from '@angular/core';
import { SwiperConfigInterface, SwiperFadeEffectInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { interval, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureTags } from 'src/app/types/feature-tags';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { ApiService } from 'src/app/shared/services/api.service';
// import * as AOS from 'aos';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit, OnDestroy {
  featureTags: FeatureTags;
  scrollPosition: number = 0;
  public HudsunSlides = [];
  public whyChooseSlides = ['assets/hudson/files/images/3/content-images/why-us-2.png', 'assets/hudson/files/images/3/content-images/why-us-3.png', 'assets/hudson/files/images/3/content-images/why-us-4.png']
  public Swconfig: SwiperConfigInterface = {
    pagination: true
  };
  private SwiperFadeEffectInterface: SwiperFadeEffectInterface = {
    crossFade: true
  }
  public HomeSliderConfig: SwiperConfigInterface = {};
  private SwiperFadeEffectInterfaceLg: SwiperFadeEffectInterface = {
    crossFade: true
  }
  slider1 = 'assets/hudson/files/images/3/content-images/slider-1.jpg';
  slider2 = 'assets/hudson/files/images/3/content-images/slider-2.jpg';     
  dynamicContent: string = '';
  contents: string[] = ['MILK', 'Eggs', 'Butter', 'Yogurt', 'CHEESE', 'Produce', 'Beef', 'Poultry', 'PORK'];
  private contentSubscription: Subscription;
  private destroy$ = new Subject<void>();
  constructor(@Inject(PLATFORM_ID) private platformId: Object,
  private apiService: ApiService,
  public sharedDataService: SharedDataService
) {}
  ngOnInit(): void {

    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));

    this.HudsunSlides = [
      { title: 'Get the best', subtitle: 'Delivered To Your Door', image: this.slider1 },
      { title: 'Get the best', subtitle: 'Delivered To Your Door', image: this.slider2 }
    ];
    if(isPlatformBrowser(this.platformId)) {
    }

    if(!!this.featureTags && this.featureTags['sf_header_cart_count']){
      this.sharedDataService.cartResponse$.pipe(
        takeUntil(this.destroy$)
      ).subscribe(res => {        
        this.getCartCount();
      });      
    }
  }
  ngAfterViewInit() {
    if(isPlatformBrowser(this.platformId)) {
      // AOS.init({
      //   duration: 1200,
      //   easing: 'ease-in-out',
      //   once: true
      // });
      this.startDynamicContentUpdate();
      this.HomeSliderConfig = {
        slidesPerView: 1,
        spaceBetween: 0,        
        loop: true,
        speed: 800,
        effect: "fade"
      };
    }
  }
  startDynamicContentUpdate(): void {
    this.contentSubscription = interval(1000)
      .pipe(
        map(i => this.contents[i % this.contents.length])
      )
      .subscribe(content => {
        this.dynamicContent = content;
    });
   
  }
  
  ngOnDestroy(): void {
    if (this.contentSubscription) {
      this.contentSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  getCartCount() {
    if (this.apiService.loggedIn()) {
      this.sharedDataService.getOrderData();
    }
  }
}
